export default __webpack_public_path__ + "static/cafe_36057-a8d3a5bc26a22d60d72470f28bf30a7f.png";